<div class="loginNewPage" *ngIf="!projectOpen">
  <div class="loginLeft projectOpenExistingPart">
    <div class="logInParts">
      <div class="row sideLoginPart">
      </div>
      <div class="sideLoginPart bottomSignIn h-75 min-height-300px">
        <div class="row full-width leftPanelTop card p-3 mb-2 min-height-300px formDiv h-100">
          <div class="h-100">
            <ul class="nav nav-tabs">
              <li class="active" id="projectselectOpenExisting">
                <a class='text-color-white' data-toggle="tab" [ngClass]="{ 'active':activeTab==='openExisting'}"
                  (click)="shiftTabs('openExisting')">
                  {{ 'projectOpen' | translate }}
                </a>
              </li>
              <li id="projectselectCreateNew">
                <a class='text-color-white' data-toggle="tab" [ngClass]="{ 'active':activeTab==='createNew'}"
                  (click)="shiftTabs('createNew');clearImportDetails()">
                  {{ 'projectCreateNew' | translate }}
                </a>
              </li>
              <li id="ApplicationreateNew">
                <a class='text-color-white' data-toggle="tab" [ngClass]="{ 'active':activeTab==='application'}"
                  (click)="shiftTabs('application');clearImportDetails()">
                  {{ 'CreateApplication' | translate }}
                </a>
              </li>
              <!-- <li id="LocalProjectOpen">
                <a class='text-color-white' data-toggle="tab" [ngClass]="{ 'active':activeTab==='local'}"
                  (click)="shiftTabs('local');clearImportDetails()">
                 local
                </a>
              </li> -->
            </ul>
            <div class="tab-content open-existing-tab-content-height">
              <div class="tab-pane fade in h-100" id="createNew" [ngClass]="{ 'active':activeTab==='createNew'}">
                <div class="h-100">
                  <div class=" mt-1">
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{selectedApplication.name || 'selectApp' | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-100 scrollable-menu cursorPointer">
                        <li class="row padding-vertical pl-2 pr-2" *ngFor="let app of applicationsList"
                          (click)="chooseApplication(app)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{app.name}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="form-account m-0">
                    <input type="text" name="projectName" class="form-input-feild"
                      (ngModelChange)="checkImportCheckbox(newProjectNameDetails,importCheck)"
                      [(ngModel)]="newProjectNameDetails" [placeholder]="'phNewMenuName'|translate" required>
                  </div>
                  <div class="form-account m-0 create-new-tab-project-desc-height text-color-white">
                    <textarea type="text" name="projectDesc" class="form-control h-100"
                      [(ngModel)]="newProjectDescDetails" [placeholder]="'phNewDescription'|translate"
                      required></textarea>
                  </div>
                  <div class="row margin-collapsable menuItemsClrWhite">
                    <div id="import" class="col-xs-11">
                      <input type="checkbox" [checked]="importCheck" [(ngModel)]="importCheck"
                        [ngClass]="{ dis:newProjectNameDetails=='' || newProjectNameDetails==null}">
                      <label>{{ 'import' | translate }}</label>
                    </div>
                    <div class="col-xs-1">
                      <span class="floatright" *ngIf="importComplete == true && importCheck == true" type="button"
                        (click)="cancelImport()">
                        <fa-icon class="fas" [icon]="faTimes"></fa-icon>
                      </span>
                    </div>
                  </div>
                  <div class="file-upload form-account m-0" *ngIf="importCheck==true">
                    <div class="file-select" >
                      <div class="file-select-button" id="fileName">{{ 'choosefile' | translate }}</div>
                      <div class="file-select-name" *ngIf="!uploadFileName" id="noFile">{{ 'nofilechoosen' | translate
                        }}</div>
                      <div class="file-select-name" *ngIf="uploadFileName" id="noFile">{{ uploadFileName}}</div>
                      <input class="form-input-feild p-0 mt-0 mb-0" type="file" name="chooseFile" id="chooseFile"
                        accept=".json,application/json" (change)="showContent($event)">
                    </div>
                  </div>
                  <div class=" mt-1" *ngIf="importCheck==false">
                    <div class="dropdown" *ngIf="projects.length > 0">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{selectedBaseProject.projectDetails.name || 'selectBase' | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-100 scrollable-menu cursorPointer">
                        <li class="row padding-vertical pl-2 pr-2" *ngFor="let project of projects"
                          (click)="chooseBaseProject(project)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{project.projectDetails.name}}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div *ngIf="!importComplete">
                    <div *ngIf="!importCheck">
                      <button class="form-submit-button" [ngClass]="{ dis:addProjectBtnDisabled==true}"
                        (click)="addProject('add', newProject)">{{ 'add' | translate }}
                      </button>
                    </div>
                    <div *ngIf="importCheck">
                      <button class="form-submit-button" *ngIf="listOfparams.length == 0" (click)="openImportModal()">
                        {{ 'add' | translate }}</button>
                      <button class="form-submit-button" (click)="openImportModal()" *ngIf="listOfparams.length > 0">
                        {{ 'import' | translate }}</button>
                    </div>
                  </div>
                  <div *ngIf="importComplete">
                    <button (click)="addJsonAsProject()" routerLink="/main/landscaper"
                      [ngClass]="{ dis:addProjectBtnDisabled==true}" class="form-submit-button">Create</button>
                  </div>
                  <div id="snackbar1">
                    <div class="text-message">{{toastMsg}}</div>
                  </div>
                </div>
              </div>
              <div id="openExisting" [ngClass]="{ 'active':activeTab==='openExisting'}"
                class="tab-pane fade in active h-100" ui-sortable>
                <div class="tab-separable open-existing-tab-table-list-height table-bordered">
                  <div class="h-90">

                    <div class=" m-0">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              <span>
                                {{selectedApplication.name || 'selectApp' | translate}}
                              </span>
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <!-- data-target="#openProjectFromLocal" -->
                        <ul class="dropdown-menu text-color-black w-100 scrollable-menu cursorPointer">
                          <li class="row padding-vertical pl-2 pr-2" data-toggle="modal"
                            (click)="chooseApplication('Local')">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                              ----Choose from local----
                            </div>
                          </li>
                          <li class="row padding-vertical pl-2 pr-2" *ngFor="let app of applicationsList"
                            (click)="chooseApplication(app)">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                              {{app.name}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-account m-0 p-0 cursorPointer">
                      <input type="text" id="searchField"
                        class="form-input-feild margintop1px marginbottom1px border-radius-0px"
                        [(ngModel)]="currProjectName" list="myProjects" [placeholder]="'projectSearch'|translate"
                        (ngModelChange)="setCurrentProjectFromDL(currProjectName)" autocomplete="off" required>
                      <datalist id="myProjects" *ngIf="projects.length != 0">
                        <option *ngFor="let project of projects; let tabIndex = index">
                          {{project.projectDetails.name}}
                        </option>
                        <option *ngIf="projects.length == 0">
                          {{ 'noProjectsCreated' | translate }}
                        </option>
                      </datalist>
                    </div>
                    <div
                      class="col-xs-12 tab-separable p-0 overflowYTextAuto open-existing-tab-table-project-list-height">
                      <table class="table table-bordered-bottom env ui-sort-per mb-0 projectListTable overflowYTextAuto"
                        id="myProjectsList">
                        <tbody class="overflowYTextAuto cursorPointer">
                          <tr class="ui-sortable-item strict clickable-row border-bottom1px"
                            *ngFor="let project of projects; let tabIndex = index" (click)="ClickedRow(tabIndex)"
                            [class.active]="tabIndex == HighlightRow">
                            <td class="col-xs-12" *ngIf="projectsLoaded == true && projects.length != 0"
                              (click)="setCurrentProject(project)">
                              <span>
                                <span *ngIf="project.projectDetails.readOnly == true">
                                  <fa-icon [class.active]="tabIndex == HighlightRow" class="fa" [icon]="faLock">
                                  </fa-icon>
                                  &nbsp;
                                </span>
                                {{project.projectDetails.name}}
                              </span>
                            </td>
                          </tr>
                          <tr *ngIf="projectsLoaded == false">
                            <td class="no-padding">
                              <button class="btn btn-default btn-block btn-xs">
                                <span>
                                  {{ 'noProjectsCreated' | translate }}
                                </span>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="projectsLoaded == true && projects.length == 0">
                            <td class="no-padding">
                              <button class="btn btn-default btn-block btn-xs">
                                <span>
                                  {{ 'noProjectsCreated' | translate }}
                                </span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="open-existing-tab-project-desc-height">
                  <textarea readonly
                    class="form-control table-bordered open-existing-tab-project-desc-height cursorPointer"
                    [(ngModel)]="currProjectDescDetails" [placeholder]="'existProjectDesc'|translate">
                      </textarea>
                </div>
                <div class="form-element mb-0" *ngIf="showChooseFile == true">
                  <div class="tab-separable open-existing-tab-table-list-height table-bordered">
                    <div class="file-upload form-account m-0">
                      <div class="file-select">
                        <div class="file-select-button" id="fileName">{{ 'choosefile' | translate }}</div>
                        <div class="file-select-name" *ngIf="!uploadFileName" id="noFile">{{ 'nofilechoosen' | translate
                          }}</div>
                        <div class="file-select-name" *ngIf="uploadFileName" id="noFile">{{ uploadFileName}}</div>
                        <input class="form-input-feild p-0 mt-0 mb-0" type="file" name="chooseFile" id="chooseFile"
                          accept=".json,application/json" (change)="showContent($event)">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="open-existing-tab-project-open-button-height">
                  <button class="form-submit-button" id="projectselectExistOpen" routerLink="/main/landscaper"
                    (click)='manageSelectProjectOpen(currProject)'>
                    {{ 'open' | translate }}&nbsp;&nbsp;
                    <fa-icon class="fa fa-spin icon-black projectOpenSpinner" [icon]="faSpinner"></fa-icon>
                  </button>

                </div>

                <div id="snackbar1">
                  <div class="text-message">
                    {{toastMsg}}
                  </div>
                </div>
              </div>
              <div class="tab-pane fade in h-100" id="application" [ngClass]="{ 'active':activeTab==='application'}">
                <div class="h-100">
                  <div class="form-account m-0">
                    <input type="text" name="projectName" class="form-input-feild"
                      [(ngModel)]="newApplicationNameDetails" [placeholder]="'applicationName'|translate" required>
                  </div>
                  <div class="form-account m-0 create-new-tab-project-desc-height text-color-white">
                    <textarea type="text" name="projectDesc" class="form-control h-100"
                      [(ngModel)]="newApplicationDescDetails" [placeholder]="'applicationDescription'|translate"
                      required></textarea>
                  </div>
                  <div>
                    <div>
                      <button class="form-submit-button" [ngClass]="{ dis:addApplicationBtnDisabled==true}"
                        (click)="addApplication()">{{ 'add' | translate }}
                      </button>
                    </div>
                  </div>
                  <div id="snackbar2">
                    <div class="text-message">{{toastMsg}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" ui-sortable>
              <!-- <ui-switch></ui-switch> -->
            </div>
          </div>
        </div>
      </div>
      <div class="sideLoginPart">
        <div class="login-footer">
          <a href="" class="form-account-options">{{ 'termsOfService' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'privacyPolicy' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'security' | translate }}</a>
        </div>
        <div class="row">
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-align-center">
            <!-- <select #langSelect (change)="translate.use(langSelect.value)">
              <option *ngFor="let lang of languages" [value]="lang.short"
                [selected]="lang.short === translate.currentLang">
                {{ lang.fullform }}
              </option>
            </select> -->
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
        </div>
      </div>
      <div class="loginSecondPart">
        <div class="logInParts">
          <div class="loginRightSide pt-0">
            <div class="centerImage">
              <img class="pb-3" src="../assets/images/1.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="importSelectionModal" class="modal fade" role="dialog">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h5 class="modal-title">{{ 'importTitle' | translate }}</h5>
          </div>
          <div class="modal-body">
            <div class="row strict">
              <div class="col-xs-1">
                <div style="text-align: center;">
                  <input type="checkbox" [checked]="isAllSelected()"
                    (click)="selectAllForImport($event.target.checked)">
                </div>
              </div>
              <label>{{ 'selectAll' | translate }}</label>
            </div>
            <div class="import-table table-responsive">
              <table class="table table-bordered">
                <tbody>
                  <tr class="row strict" *ngFor="let item of listOfparamsForImportList">
                    <div>
                      <td class="col-xs-1">
                        <div style="text-align: center;">
                          <input type="checkbox" [checked]="presentInImportList(item,item.value)"
                            (click)="changeinImport(item,$event.target.checked)">
                        </div>
                      </td>
                      <td class="col-xs-11">
                        {{item}}
                      </td>
                    </div>
                  </tr>
                  <!-- old json import code open  -->
                  <!-- <tr class="row strict" *ngFor="let item of content | keyvalue">
                    <div
                      *ngIf="((item.key)=='listOfAttributes'||(item.key)=='myNotes'||(item.key)=='suites'||(item.key)=='envMap'||(item.key)=='listOfEnv'||(item.key)=='scenarios'||(item.key)=='interactionMap'||(item.key)=='personaMap'||(item.key)=='scopeMap'||(item.key)=='EUTdetails'||(item.key)=='listOfEUTs'||(item.key)=='checklists'||(item.key)=='persona')&&((item.value).length>0)">
                      <td class="col-xs-1">
                        <div style="text-align: center;">
                          <input type="checkbox" [checked]="presentInImportList(item.key,item.value)"
                            (click)="changeinImport(item.key,$event.target.checked)">
                        </div>
                      </td>
                      <td class="col-xs-11">
                        {{item.key}}
                      </td>
                    </div>
                  </tr> -->
                  <!-- old json import code close  -->
                </tbody>
              </table>
            </div>
            <div class="row redText text-align-center pb-0" *ngIf="listOfparams.length == 0">
              {{ 'emptyNoteText' | translate }}
            </div>
          </div>
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per minwidth75px"
              (click)="setImportComplete()" data-dismiss="modal">Ok</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{ 'cancel' |
              translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Open project from local modal -->
<div class="modal fade" id="openProjectFromLocal" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <form novalidate id="intelligent-assistant-form" class="form-group">
                <div class="form-header title text-align-center text-color-black">Invalid Project file.
                  Please choose a valid file.
                </div>
                <div class="form-element mb-0" style="display: none !important;">
                  <div class="tab-separable open-existing-tab-table-list-height table-bordered">
                    <div class="file-upload form-account m-0">
                      <div class="file-select">
                        <div class="file-select-button" id="fileName">{{ 'choosefile' | translate }}</div>
                        <div class="file-select-name" *ngIf="!uploadFileName" id="noFile">{{ 'nofilechoosen' | translate
                          }}</div>
                        <div class="file-select-name" *ngIf="uploadFileName" id="noFile">{{ uploadFileName}}</div>
                        <input class="form-input-feild p-0 mt-0 mb-0" type="file" name="chooseFile" id="chooseFile"
                          accept=".json,application/json" (change)="showContent($event)">
                      </div>
                    </div>
                  </div>
                </div>



              </form>
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-align-center">
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per minwidth75px"
              (click)="chooseApplication('Local')" data-dismiss="modal">Ok</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{ 'cancel' |
              translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>